module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-06-23",
		"endpointPrefix": "devicefarm",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Device Farm",
		"signatureVersion": "v4",
		"targetPrefix": "DeviceFarm_20150623",
		"uid": "devicefarm-2015-06-23"
	},
	"operations": {
		"CreateDevicePool": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"name",
					"rules"
				],
				"members": {
					"projectArn": {},
					"name": {},
					"description": {},
					"rules": {
						"shape": "S5"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devicePool": {
						"shape": "Sb"
					}
				}
			}
		},
		"CreateNetworkProfile": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"name"
				],
				"members": {
					"projectArn": {},
					"name": {},
					"description": {},
					"type": {},
					"uplinkBandwidthBits": {
						"type": "long"
					},
					"downlinkBandwidthBits": {
						"type": "long"
					},
					"uplinkDelayMs": {
						"type": "long"
					},
					"downlinkDelayMs": {
						"type": "long"
					},
					"uplinkJitterMs": {
						"type": "long"
					},
					"downlinkJitterMs": {
						"type": "long"
					},
					"uplinkLossPercent": {
						"type": "integer"
					},
					"downlinkLossPercent": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"networkProfile": {
						"shape": "Si"
					}
				}
			}
		},
		"CreateProject": {
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"defaultJobTimeoutMinutes": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"project": {
						"shape": "Sm"
					}
				}
			}
		},
		"CreateRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"deviceArn"
				],
				"members": {
					"projectArn": {},
					"deviceArn": {},
					"name": {},
					"configuration": {
						"type": "structure",
						"members": {
							"billingMethod": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"remoteAccessSession": {
						"shape": "Ss"
					}
				}
			}
		},
		"CreateUpload": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"name",
					"type"
				],
				"members": {
					"projectArn": {},
					"name": {},
					"type": {},
					"contentType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"upload": {
						"shape": "S18"
					}
				}
			}
		},
		"DeleteDevicePool": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteNetworkProfile": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteProject": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteRun": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteUpload": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"GetAccountSettings": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"accountSettings": {
						"type": "structure",
						"members": {
							"awsAccountNumber": {},
							"unmeteredDevices": {
								"shape": "S1s"
							},
							"unmeteredRemoteAccessDevices": {
								"shape": "S1s"
							},
							"maxJobTimeoutMinutes": {
								"type": "integer"
							},
							"trialMinutes": {
								"type": "structure",
								"members": {
									"total": {
										"type": "double"
									},
									"remaining": {
										"type": "double"
									}
								}
							},
							"maxSlots": {
								"type": "map",
								"key": {},
								"value": {
									"type": "integer"
								}
							},
							"defaultJobTimeoutMinutes": {
								"type": "integer"
							}
						}
					}
				}
			}
		},
		"GetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"device": {
						"shape": "Sv"
					}
				}
			}
		},
		"GetDevicePool": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devicePool": {
						"shape": "Sb"
					}
				}
			}
		},
		"GetDevicePoolCompatibility": {
			"input": {
				"type": "structure",
				"required": [
					"devicePoolArn"
				],
				"members": {
					"devicePoolArn": {},
					"appArn": {},
					"testType": {},
					"test": {
						"shape": "S21"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"compatibleDevices": {
						"shape": "S25"
					},
					"incompatibleDevices": {
						"shape": "S25"
					}
				}
			}
		},
		"GetJob": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"job": {
						"shape": "S2b"
					}
				}
			}
		},
		"GetNetworkProfile": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"networkProfile": {
						"shape": "Si"
					}
				}
			}
		},
		"GetOfferingStatus": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"current": {
						"shape": "S2i"
					},
					"nextPeriod": {
						"shape": "S2i"
					},
					"nextToken": {}
				}
			}
		},
		"GetProject": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"project": {
						"shape": "Sm"
					}
				}
			}
		},
		"GetRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"remoteAccessSession": {
						"shape": "Ss"
					}
				}
			}
		},
		"GetRun": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"run": {
						"shape": "S2z"
					}
				}
			}
		},
		"GetSuite": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"suite": {
						"shape": "S32"
					}
				}
			}
		},
		"GetTest": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"test": {
						"shape": "S35"
					}
				}
			}
		},
		"GetUpload": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"upload": {
						"shape": "S18"
					}
				}
			}
		},
		"InstallToRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"remoteAccessSessionArn",
					"appArn"
				],
				"members": {
					"remoteAccessSessionArn": {},
					"appArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"appUpload": {
						"shape": "S18"
					}
				}
			}
		},
		"ListArtifacts": {
			"input": {
				"type": "structure",
				"required": [
					"arn",
					"type"
				],
				"members": {
					"arn": {},
					"type": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"artifacts": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"arn": {},
								"name": {},
								"type": {},
								"extension": {},
								"url": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListDevicePools": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"type": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devicePools": {
						"type": "list",
						"member": {
							"shape": "Sb"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListDevices": {
			"input": {
				"type": "structure",
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devices": {
						"type": "list",
						"member": {
							"shape": "Sv"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListJobs": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"jobs": {
						"type": "list",
						"member": {
							"shape": "S2b"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListNetworkProfiles": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"type": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"networkProfiles": {
						"type": "list",
						"member": {
							"shape": "Si"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListOfferingPromotions": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offeringPromotions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"id": {},
								"description": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListOfferingTransactions": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offeringTransactions": {
						"type": "list",
						"member": {
							"shape": "S40"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offerings": {
						"type": "list",
						"member": {
							"shape": "S2m"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListProjects": {
			"input": {
				"type": "structure",
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"projects": {
						"type": "list",
						"member": {
							"shape": "Sm"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListRemoteAccessSessions": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"remoteAccessSessions": {
						"type": "list",
						"member": {
							"shape": "Ss"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListRuns": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"runs": {
						"type": "list",
						"member": {
							"shape": "S2z"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListSamples": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"samples": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"arn": {},
								"type": {},
								"url": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListSuites": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"suites": {
						"type": "list",
						"member": {
							"shape": "S32"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListTests": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tests": {
						"type": "list",
						"member": {
							"shape": "S35"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListUniqueProblems": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"uniqueProblems": {
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"message": {},
									"problems": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"run": {
													"shape": "S4w"
												},
												"job": {
													"shape": "S4w"
												},
												"suite": {
													"shape": "S4w"
												},
												"test": {
													"shape": "S4w"
												},
												"device": {
													"shape": "Sv"
												},
												"result": {},
												"message": {}
											}
										}
									}
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListUploads": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"uploads": {
						"type": "list",
						"member": {
							"shape": "S18"
						}
					},
					"nextToken": {}
				}
			}
		},
		"PurchaseOffering": {
			"input": {
				"type": "structure",
				"members": {
					"offeringId": {},
					"quantity": {
						"type": "integer"
					},
					"offeringPromotionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offeringTransaction": {
						"shape": "S40"
					}
				}
			}
		},
		"RenewOffering": {
			"input": {
				"type": "structure",
				"members": {
					"offeringId": {},
					"quantity": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offeringTransaction": {
						"shape": "S40"
					}
				}
			}
		},
		"ScheduleRun": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"devicePoolArn",
					"test"
				],
				"members": {
					"projectArn": {},
					"appArn": {},
					"devicePoolArn": {},
					"name": {},
					"test": {
						"shape": "S21"
					},
					"configuration": {
						"type": "structure",
						"members": {
							"extraDataPackageArn": {},
							"networkProfileArn": {},
							"locale": {},
							"location": {
								"type": "structure",
								"required": [
									"latitude",
									"longitude"
								],
								"members": {
									"latitude": {
										"type": "double"
									},
									"longitude": {
										"type": "double"
									}
								}
							},
							"radios": {
								"type": "structure",
								"members": {
									"wifi": {
										"type": "boolean"
									},
									"bluetooth": {
										"type": "boolean"
									},
									"nfc": {
										"type": "boolean"
									},
									"gps": {
										"type": "boolean"
									}
								}
							},
							"auxiliaryApps": {
								"type": "list",
								"member": {}
							},
							"billingMethod": {}
						}
					},
					"executionConfiguration": {
						"type": "structure",
						"members": {
							"jobTimeoutMinutes": {
								"type": "integer"
							},
							"accountsCleanup": {
								"type": "boolean"
							},
							"appPackagesCleanup": {
								"type": "boolean"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"run": {
						"shape": "S2z"
					}
				}
			}
		},
		"StopRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"remoteAccessSession": {
						"shape": "Ss"
					}
				}
			}
		},
		"StopRun": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"run": {
						"shape": "S2z"
					}
				}
			}
		},
		"UpdateDevicePool": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"name": {},
					"description": {},
					"rules": {
						"shape": "S5"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devicePool": {
						"shape": "Sb"
					}
				}
			}
		},
		"UpdateNetworkProfile": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"name": {},
					"description": {},
					"type": {},
					"uplinkBandwidthBits": {
						"type": "long"
					},
					"downlinkBandwidthBits": {
						"type": "long"
					},
					"uplinkDelayMs": {
						"type": "long"
					},
					"downlinkDelayMs": {
						"type": "long"
					},
					"uplinkJitterMs": {
						"type": "long"
					},
					"downlinkJitterMs": {
						"type": "long"
					},
					"uplinkLossPercent": {
						"type": "integer"
					},
					"downlinkLossPercent": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"networkProfile": {
						"shape": "Si"
					}
				}
			}
		},
		"UpdateProject": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"name": {},
					"defaultJobTimeoutMinutes": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"project": {
						"shape": "Sm"
					}
				}
			}
		}
	},
	"shapes": {
		"S5": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"attribute": {},
					"operator": {},
					"value": {}
				}
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"description": {},
				"type": {},
				"rules": {
					"shape": "S5"
				}
			}
		},
		"Si": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"description": {},
				"type": {},
				"uplinkBandwidthBits": {
					"type": "long"
				},
				"downlinkBandwidthBits": {
					"type": "long"
				},
				"uplinkDelayMs": {
					"type": "long"
				},
				"downlinkDelayMs": {
					"type": "long"
				},
				"uplinkJitterMs": {
					"type": "long"
				},
				"downlinkJitterMs": {
					"type": "long"
				},
				"uplinkLossPercent": {
					"type": "integer"
				},
				"downlinkLossPercent": {
					"type": "integer"
				}
			}
		},
		"Sm": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"defaultJobTimeoutMinutes": {
					"type": "integer"
				},
				"created": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"message": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"device": {
					"shape": "Sv"
				},
				"billingMethod": {},
				"deviceMinutes": {
					"shape": "S13"
				},
				"endpoint": {}
			}
		},
		"Sv": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"manufacturer": {},
				"model": {},
				"formFactor": {},
				"platform": {},
				"os": {},
				"cpu": {
					"type": "structure",
					"members": {
						"frequency": {},
						"architecture": {},
						"clock": {
							"type": "double"
						}
					}
				},
				"resolution": {
					"type": "structure",
					"members": {
						"width": {
							"type": "integer"
						},
						"height": {
							"type": "integer"
						}
					}
				},
				"heapSize": {
					"type": "long"
				},
				"memory": {
					"type": "long"
				},
				"image": {},
				"carrier": {},
				"radio": {},
				"remoteAccessEnabled": {
					"type": "boolean"
				},
				"fleetType": {},
				"fleetName": {}
			}
		},
		"S13": {
			"type": "structure",
			"members": {
				"total": {
					"type": "double"
				},
				"metered": {
					"type": "double"
				},
				"unmetered": {
					"type": "double"
				}
			}
		},
		"S18": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"created": {
					"type": "timestamp"
				},
				"type": {},
				"status": {},
				"url": {},
				"metadata": {},
				"contentType": {},
				"message": {}
			}
		},
		"S1s": {
			"type": "map",
			"key": {},
			"value": {
				"type": "integer"
			}
		},
		"S21": {
			"type": "structure",
			"required": [
				"type"
			],
			"members": {
				"type": {},
				"testPackageArn": {},
				"filter": {},
				"parameters": {
					"type": "map",
					"key": {},
					"value": {}
				}
			}
		},
		"S25": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"device": {
						"shape": "Sv"
					},
					"compatible": {
						"type": "boolean"
					},
					"incompatibilityMessages": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"message": {},
								"type": {}
							}
						}
					}
				}
			}
		},
		"S2b": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"type": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"counters": {
					"shape": "S2c"
				},
				"message": {},
				"device": {
					"shape": "Sv"
				},
				"deviceMinutes": {
					"shape": "S13"
				}
			}
		},
		"S2c": {
			"type": "structure",
			"members": {
				"total": {
					"type": "integer"
				},
				"passed": {
					"type": "integer"
				},
				"failed": {
					"type": "integer"
				},
				"warned": {
					"type": "integer"
				},
				"errored": {
					"type": "integer"
				},
				"stopped": {
					"type": "integer"
				},
				"skipped": {
					"type": "integer"
				}
			}
		},
		"S2i": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S2k"
			}
		},
		"S2k": {
			"type": "structure",
			"members": {
				"type": {},
				"offering": {
					"shape": "S2m"
				},
				"quantity": {
					"type": "integer"
				},
				"effectiveOn": {
					"type": "timestamp"
				}
			}
		},
		"S2m": {
			"type": "structure",
			"members": {
				"id": {},
				"description": {},
				"type": {},
				"platform": {},
				"recurringCharges": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"cost": {
								"shape": "S2q"
							},
							"frequency": {}
						}
					}
				}
			}
		},
		"S2q": {
			"type": "structure",
			"members": {
				"amount": {
					"type": "double"
				},
				"currencyCode": {}
			}
		},
		"S2z": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"type": {},
				"platform": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"counters": {
					"shape": "S2c"
				},
				"message": {},
				"totalJobs": {
					"type": "integer"
				},
				"completedJobs": {
					"type": "integer"
				},
				"billingMethod": {},
				"deviceMinutes": {
					"shape": "S13"
				},
				"networkProfile": {
					"shape": "Si"
				}
			}
		},
		"S32": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"type": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"counters": {
					"shape": "S2c"
				},
				"message": {},
				"deviceMinutes": {
					"shape": "S13"
				}
			}
		},
		"S35": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"type": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"counters": {
					"shape": "S2c"
				},
				"message": {},
				"deviceMinutes": {
					"shape": "S13"
				}
			}
		},
		"S40": {
			"type": "structure",
			"members": {
				"offeringStatus": {
					"shape": "S2k"
				},
				"transactionId": {},
				"offeringPromotionId": {},
				"createdOn": {
					"type": "timestamp"
				},
				"cost": {
					"shape": "S2q"
				}
			}
		},
		"S4w": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/devicefarm-2015-06-23.min.json
// module id = 381
// module chunks = 0